import { useSelector } from "react-redux"
import { vnzImagesSelectors } from "~/redux/state/VNZImages"
import { RootState } from "~/redux/store"

export const useVNZImages = () => {
  // selectIds returns a stable array reference across per-image updateOne calls
  // (thumbnail loads). It only changes on add/remove, so streaming thumbnails no
  // longer force the whole grid to re-render.
  const imageIds = useSelector((state: RootState) =>
    vnzImagesSelectors.selectIds(state)
  )
  const isLoading = useSelector((state: RootState) => state.VNZImages.isLoading)
  const hasError = useSelector((state: RootState) => state.VNZImages.hasError)
  const error = useSelector((state: RootState) => state.VNZImages.error)
  const hasMore = useSelector((state: RootState) => state.VNZImages.hasMore)

  const hasLoadedImages = !isLoading && !hasError && imageIds.length > 0
  const hasNoImages =
    !isLoading && !hasError && imageIds.length === 0 && !hasMore

  return {
    imageIds,
    isLoading,
    hasError,
    error,
    hasMore,
    hasLoadedImages,
    hasNoImages,
  }
}
